// extracted by css-extract-rspack-plugin
export default {"sectionWidth":"sectionWidth-pdUSOj"};